export default {
  index: '首页',
  logOut: '退出登录',
  profile: '个人中心',
  webcomeBack: '欢迎回来',
  noName: '暂无名称',
  changeLogo: '更换公司Logo',
  logoFormatError: '请上传正确格式的图片，如png、jpg、jpeg、gif',
  innerAccount: "内部账号",
};
